import Uri from 'jsuri';

import type { NaptimeResourceType } from 'bundles/naptimejs/resources/NaptimeResource';

import type { NaptimeClientDataProcessor, NaptimeClientQuery } from './NaptimeClient';
import NaptimeClient from './NaptimeClient';

class Get<Result, Resource extends NaptimeResourceType> extends NaptimeClient<Result, Resource> {
  declare id: string | number;

  constructor(
    resource: Resource,
    id: string | number,
    data?: NaptimeClientQuery,
    dataProcessor?: NaptimeClientDataProcessor<Result, Resource>
  ) {
    super(resource, data, dataProcessor);
    this.id = id;
  }

  getBaseUri() {
    return new Uri(`/api/${this.resourceName}/${this.id}`);
  }

  isValid() {
    return this.id !== undefined;
  }

  getClientIdentifier() {
    return `Get:${this.id}|${super.getClientIdentifier()}`;
  }
}

export default Get;
